import { BaseReportPage } from './bases/BaseReportPage';
import { REPORT } from '@consts/reports';
import { SplitReportContainer } from '@components/SplitReportContainer';
import { CutsByResellerLastMonth } from '@components/reports/resellers/CutsByResellerLastMonth';
import { CutsByResellerThisMonth } from '@components/reports/resellers/CutsByResellerThisMonth';
import { CutsByReseller } from '@components/reports/resellers/CutsByReseller';
import { AverageCutsByReseller } from '@components/reports/resellers/AverageCutsByReseller';
import { FullBodyPctByReseller } from '@components/reports/resellers/FullyBodyPctByReseller';
import { WarrantyRatePctByReseller } from '@components/reports/resellers/WarrantyRateByReseller';
import { MonthlyCutVolumeGrowth } from '@components/reports/resellers/MonthlyCutVolumeByReseller';
import { NumberOfActiveLocations } from '@components/reports/resellers/NumberOfActiveLocations';
import { Button, Grid } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import { AppRoutes } from '@consts/routes';
import { ReportTips } from '@components/ReportTips';

interface ResellerProps {
    showTips: boolean;
    dateRange: { startDate: string; endDate: string };
    setDateRange: (dateRange: { startDate: string; endDate: string }) => void;
}

export const Resellers = ({ showTips, dateRange, setDateRange }: ResellerProps) => {
    const navigate = useNavigate();

    return (
        <BaseReportPage dateRange={dateRange} setDateRange={setDateRange} title={'MO Insights Resellers'}>
            {showTips && <ReportTips reportType={REPORT.RESELLER_TIPS} />}

            <SplitReportContainer
                reports={[<CutsByResellerLastMonth key={1} />, <CutsByResellerThisMonth key={2} />]}
            />

            <CutsByReseller dateRange={dateRange} />

            <AverageCutsByReseller dateRange={dateRange} />

            <FullBodyPctByReseller dateRange={dateRange} />

            <WarrantyRatePctByReseller dateRange={dateRange} />

            <MonthlyCutVolumeGrowth dateRange={dateRange} />

            <NumberOfActiveLocations dateRange={dateRange} />

            <Grid item xs={12} textAlign={'center'} marginTop={'20px'}>
                <Button color={'primary'} variant={'contained'} onClick={() => navigate(AppRoutes.ResellersSecondary)}>
                    More Reports Available on the Next Page &nbsp; <b>1</b>
                </Button>
            </Grid>
        </BaseReportPage>
    );
};
